import styled from 'styled-components';

export const StyledChat = styled.div`
  display: none;

  a {
    border-radius: ${props => props.theme.borderRadius};
    font-size: ${props => props.theme.fontSizes.small};
    text-align: center;
    padding: 30px;
    margin: 30px 15px;
    background: #f8f8f8;
    display: block;
    text-decoration: none;

    svg {
      display: block;
      margin: 0 auto 10px;
      font-size: 24px;
    }
  }

  @media(max-width: ${props => props.theme.breakpoints.mobile}) {
    display: block;
  }
`
